const constants = {
    UPDATE_PALETTE: 'UPDATE_PALETTE', //updateColorPalette & updateUserPalette

    UPDATE_COLOR_ATTR: 'UPDATE_COLOR_ATTR', //update cx, cy, radius based on window resizing

    COPY_COLOR_TO_CLIPBOARD: 'COPY_COLOR_TO_CLIPBOARD',

    REMOVE_PALETTE: 'REMOVE_PALETTE', //remove an entire palette
    SELECT_ALL_COLORS: 'SELECT_ALL_COLORS', //select all colors in a palette
    
    SUBTRACT_COLOR_PALETTE: 'SUBTRACT_COLOR_PALETTE', //subtract the newly added palette
    ADD_COLOR_PALETTE: 'ADD_COLOR_PALETTE', //add interpolater function in our list of functions

    TRASH_ALL: 'TRASH_ALL',
    RANDOMIZE_COLORS: 'RANDOMIZE_COLORS',

    SIMULATE: 'SIMULATE',

    CHANGE_VIZ: 'CHANGE_VIZ',
    CHANGE_MEDIA: 'CHANGE_MEDIA',

    CHANGE_THEME: 'CHANGE_THEME',

    DOWNLOAD_CSV: 'DOWNLOAD_CSV',
    DOWNLOAD_JSON: 'DOWNLOAD_JSON',
    DOWNLOAD_JPEG: 'DOWNLOAD_JPEG',
    DOWNLOAD_ARR: 'DOWNLOAD_ARR',

    DOWNLOAD_VIZ: 'DOWNLOAD_VIZ',
}

export default constants